module.exports = {"TXTWCL_Unlock":{"id":"TXTWCL_Unlock","defaultMessage":"Lås upp","flags":["TRACK"],"track":"Unlock"}}